import { useEffect } from "react";
import { useRegeneratePDF } from "../api/ReportsApi";

import {
  CheckBadgeIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";
import { useApplicationToast } from "../webcontent/ApplicationToastProvider";

const useRegeneratePDFWithToast = () => {
  const { showLargeToast } = useApplicationToast();

  const {
    mutate: regeneratePDF,
    error: errorGeneratePDF,
    isLoading: loadingGeneratePDF,
    isSuccess: successGeneratePDF,
  } = useRegeneratePDF();

  useEffect(() => {
    if (errorGeneratePDF) {
      showLargeToast?.({
        title: "Error!",
        message:
          "Couldn't regenerate the PDF please try again later or contact support.",
        icon: (
          <div className="bg-red-100 text-red-600 rounded-full p-2">
            <ExclamationTriangleIcon className="w-6" />
          </div>
        ),
      });
    }
  }, [errorGeneratePDF, showLargeToast]);

  useEffect(() => {
    if (successGeneratePDF) {
      showLargeToast?.({
        title: "Regenerating PDF",
        message:
          "Your PDF is being regenerated, please wait a few minutes and refresh the page.",
        icon: (
          <div className="bg-green-100 text-green-600 rounded-full p-2">
            <CheckBadgeIcon className="w-6" />
          </div>
        ),
      });
    }
  }, [successGeneratePDF, showLargeToast]);

  return {
    regeneratePDF,
    loadingGeneratePDF,
    errorGeneratePDF,
    successGeneratePDF,
  };
};

export default useRegeneratePDFWithToast;
